export const getKindText = (kind) => {
  if (kind == 'weekly') return 'pick’em';
  if (kind == 'survive') return 'survivor';

  return 'N/A';
};
